import React from 'react';
import withSplashMessage from './withSplashMessage';
import SplashMessage from './SplashMessage';

class SplashMessages extends React.Component {
  render() {
    const { messages, isNewDash } = this.props;
    return (
      <div className="splash-message__container">
        {messages.map(
          (message, key) =>
            !isNewDash && <SplashMessage key={key} message={message} /> // Using SplashMessageNew Component in new designs
        )}
      </div>
    );
  }
}
export default withSplashMessage(SplashMessages);



// WEBPACK FOOTER //
// ./src/components/splashMessage/SplashMessages.js